import { render } from "./EventEditorPage.vue?vue&type=template&id=06d4e5a4&scoped=true"
import script from "./EventEditorPage.vue?vue&type=script&lang=js"
export * from "./EventEditorPage.vue?vue&type=script&lang=js"

import "./EventEditorPage.vue?vue&type=style&index=0&id=06d4e5a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d4e5a4"]])

export default __exports__